export default __webpack_public_path__ + "static/media/singapore.4d575857.png";